<template>
  <div
    id="index"
    v-cloak
  >
    <div class="visible-xs min_index">
      <header class="flex_center m_header">
        <i
          class="esc"
          @click="goBackward"
        ><img
            src="@/assets/img/esc_fan.png"
            alt=""
          ></i>
        <h4 class="header_title">关注</h4>
        <i
          class="rigth_button"
          @click.stop="state = true"
          v-if="!state"
        >
          管理
        </i>
        <span
          class="rigth_button"
          v-else
          @click.stop="state = false"
        >
          取消
        </span>
      </header>
      <!-- 内容 -->
      <div class='integral_div'>
        <div class="poure34">
          <div
            @click="openre(0)"
            :class="{acticls43:is_cate34===0}"
          >文章分类</div>
          <div
            @click="openre(1)"
            :class="{acticls43:is_cate34===1}"
          >视频分类</div>
        </div>
        <div
          class="list_ul flex_between"
          v-if="list_ul.length>0"
        >
          <div
            class="list_li flex_center"
            :class="{'selsected':liem.is_selected&&state}"
            @click.stop="detailsFun(index,liem.id)"
            v-for="(liem,index) in list_ul"
            :key="liem.id"
          >
            <i
              class="gou_icon"
              v-if="state"
            >
              <img
                v-if="!liem.is_selected"
                src="@/assets/img/gou.png"
                alt=""
              >
              <img
                v-else
                src="@/assets/img/gouT.png"
                alt=""
              >
            </i>
            <i class="li_icon"> <img
                v-if="liem.image"
                :src="liem.image"
                alt=""
              >
              <img
                v-else
                src="@/assets/img/app_logo.png"
                alt=""
              ></i>
            <h4>{{liem.title}}</h4>
          </div>
        </div>
        <div
          class="no_center flex_center"
          v-else
        >
         <div class="spinner-box" v-if="is_loading&&!idloading">
                <img
                  src="@/assets/img/kkry_pc.gif"
                  alt=""
                >
                <div>空空如也...</div>
              </div>
          <div
            class="flex_center prompt_text"
            v-if="is_loading&&!idloading"
          >
            暂无关注，前往推荐看看吧! <a
              v-if="is_cate34===0"
              href="javaScript:void(0)"
              @click.stop="geHome(0)"
            >推荐</a>
            <a
              v-else
              href="javaScript:void(0)"
              @click.stop="geHome(1)"
            >推荐</a>
          </div>
          <div
            class=""
            v-else
          >
            <div v-if="idloading">
              <div class="spinner-box">
                <img
                  src="@/assets/img/loadding_pc.gif"
                  alt=""
                >
                <div>努力加载中...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bottom_button flex_between"
        v-if="state"
      >
        <div
          class="flex_center button_left"
          @click="reinstall(1)"
        >
          <i> <img
              v-if="!is_selected"
              src="@/assets/img/gou.png"
              alt=""
            >
            <img
              v-else
              src="@/assets/img/gouT.png"
              alt=""
            >
          </i>
          全选
        </div>
        <button
          class="flex_center button_right"
          @click="delFun"
          v-if="is_cate34===0"
          :class="{'point':selsected_arr.length>0}"
        >取消关注</button>
        <button
          class="flex_center button_right"
          @click="delFunvedio"
          v-if="is_cate34===1"
          :class="{'point':selsected_arr.length>0}"
        >取消关注</button>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/js/swiper.animate1.0.3.min.js";
import "@/assets/css/animate.min.css";
import "@/assets/css/video-js.min.css";

export default {
  name: "index",
  data () {
    return {
      user: {},//用户信息
      state: false,//是否管理
      list_ul: [],
      is_selected: false,//全选
      selsected_arr: [],//删除
      page: 1,

      is_loading: false,//加载
      is_cate34: 0,
      idloading:true
    };
  },
  computed: {},
  components: {

  },
  watch: {

  },
  methods: {
    openre (id) {
      this.idloading=true
      this.is_cate34 = id
      this.state = false
      this.list_ul = []
      this.getList()
      this.is_selected = false
    },
    delFun () {
      if (this.selsected_arr.length <= 0) {
        return false;
      }
      let that = this;
      layer.open({
        content: '确定要取消关注吗？'
        , style: 'background-color:#fff; color:#33333;font-size:18px; border:none;' //自定风格
        , btn: ['确定', '取消']
        , yes: function (index) {
          // location.reload();
          layer.close(index);
          that.$post('follow', {
            conf_id: that.selsected_arr.join(","),
            member_id: that.USER().id,
            type: 2,
          }).then(res => {
            layer.open({
              content: "取消关注成功",
              time: true,
              skin: "msg"
            });
            that.state = false;
            that.page = 1;
            that.getList();
          })
        }
      });
    },
    delFunvedio () {
      if (this.selsected_arr.length <= 0) {
        return false;
      }
      let that = this;
      layer.open({
        content: '确定要取消关注吗？'
        , style: 'background-color:#fff; color:#33333;font-size:18px; border:none;' //自定风格
        , btn: ['确定', '取消']
        , yes: function (index) {
          // location.reload();
          layer.close(index);
          that.$post('follow', {
            conf_id: that.selsected_arr.join(","),
            member_id: that.USER().id,
            type: 2,
            class: "video",
          }).then(res => {
            layer.open({
              content: "取消关注成功",
              time: true,
              skin: "msg"
            });
            that.state = false;
            that.page = 1;
            that.getList();
          })
        }
      });
    },
    // detailsFun (index) {
    //   if (this.state) {
    //     this.list_ul[index].is_selected = !this.list_ul[index].is_selected;
    //     this.reinstall();
    //   } else {
    //     this.$store.commit('setColumn', this.list_ul[index].id);
    //     this.$router.replace("/m_column");
    //   }
    // },
    detailsFun (index, id) {
      if (this.state) {
        this.list_ul[index].is_selected = !this.list_ul[index].is_selected;
        this.reinstall();
      } else {
        if (this.list_ul[index].class === "video") {
          this.$router.push({ path: '/m_vedio_index', query: { id: id } });
        } else {
          this.$store.commit('setColumn', this.list_ul[index].id);
          this.$router.replace("/m_column");
        }
      }
    },
    reinstall (type) {//组装数据
      this.selsected_arr = [];
      let that = this;
      this.list_ul.forEach((element, index) => {
        if (type == 1 && !this.is_selected) {
          that.list_ul[index].is_selected = true;
        }
        if (type == 1 && this.is_selected) {
          that.list_ul[index].is_selected = false;
        }
        if (that.list_ul[index].is_selected) {
          that.selsected_arr.push(element.id);
        }
      });
      if (this.selsected_arr.length >= this.list_ul.length) {
        this.is_selected = true;
      } else {
        this.is_selected = false;
      }
    },
    geHome (id) {//返回首页
      if (id === 0) {
        this.$router.replace('/m_column');
      } else {
        this.$router.replace('/m_vedio_index');
      }
    },
    goBackward () {//返回上一页
      this.$router.go(-1)
    },
    getUser () {
      let that = this;
      this.REFRESH_USER();
      that.user = this.USER();
      this.getList();
    },
    getList () {
      let that = this;
      if (this.page == 1) {
        this.list_ul = [];
      }
      this.$post('follow_comment', {
        type: 2,//1评论2关注3收藏
        member_id: this.USER().id,

      }).then(res => {
      this.idloading=false
        that.is_loading = true;
        let arr = []
        if (this.is_cate34 === 0) {
          arr.push(...res.data.news)

        } else {
          arr.push(...res.data.video)
        }
        if (arr) {
          arr.forEach((element, index) => {
            arr[index].is_selected = false;
          });
        }
         
        that.list_ul = arr;
      })
    },
  },
  mounted () {
    this.getUser();
    this.getShare();
    if (this._isMobile()) {
    } else {
      // alert("pc端");
      this.$router.replace("/");
    }
    let that = this;
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();
      // if (scrollTop + windowHeight + 2 >= scrollHeight) {
      //     that.page++;
      //     that.getList();
      // }
    });
  }
};
</script>

<style scoped>
html,
body {
  max-width: 100vw;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem;
}

/* 内容 */
.list_ul {
  /* padding: 1.5rem 1rem; */
  font-size: 0;
  flex-wrap: wrap;
  padding: 0px 1rem;
}

.list_ul .list_li {
  width: calc(50% - 2rem);
  height: 15.8rem;
  border: 1px solid #999999;
  position: relative;
  flex-direction: column;
  display: inline-flex;
  border-radius: 1rem;
  margin: 1rem 0px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.list_ul .list_li.selsected {
  border-color: #f24d5b;
}

.list_ul .list_li .gou_icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 1.8rem;
  height: 1.8rem;
}

.list_ul .list_li .li_icon {
  width: 6.5rem;
  height: 6.5rem;
  font-size: 0;
  margin-bottom: 2rem;
}

.list_ul .list_li > h4 {
  font-size: 1.8rem;
  font-weight: bold;
  color: #f5ab16;
}

/* 底部按钮 */
.bottom_button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  height: 4.5rem;
  box-shadow: 0 0 9px rgba(71, 71, 71, 0.11);
}

.bottom_button .button_left {
  padding-left: 1.5rem;
  height: 100%;
  font-size: 1.4rem;
  color: #999;
}

.bottom_button .button_left > i {
  width: 1.4rem;
  margin-right: 0.9rem;
}

.bottom_button .button_right {
  width: 15rem;
  height: 100%;
  background: #bfbfbf;
  color: #fff;
  font-size: 1.4rem;
  border: 0;
}

.bottom_button .button_right.point {
  background: #f24d5b;
}

/* 暂无数据 */
.no_center {
  flex-direction: column;
  /* padding-top: 50vh;
  transform: translateY(-50%); */
}

.no_center > i {
  width: 80vw;
  margin-bottom: 2.5rem;
}

.no_center .prompt_text {
  font-size: 1.4rem;
  color: #666;
}

.no_center .prompt_text > a {
  color: #f24d5b;
  margin-left: 10px;
}
.poure34 {
  display: flex;
  justify-content: space-around;
}
.poure34 div {
  padding: 10px 0px;
  border-bottom: #ffffff00 2px solid;
}
.acticls43 {
  border-bottom: #f24d5b 2px solid !important;
}
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_focus.vue